import { ApiStation, ApiStationEditableMetadata } from '../api/ApiTypes';
import CitadelImage from '../images/citadel_default.jpg';

export class StationUtil {
    static getImage(org: ApiStation | ApiStationEditableMetadata) {
        if (org.imageUrl) return org.imageUrl;
        return CitadelImage;
    }
}
